import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndo, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';

class NuevoReporte extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            cargando: false,
            servicios: [],
            estadosList: [],
            clientesList: [],
            filtros: {
                fecha_inicio: '2026-09-01',
                fecha_fin: '2026-09-30',
                estado: '',
                numero_expediente: '',
                orden_servicio_new: '',
                cliente_id: '',
                mostrar_costo_conductor_nc: false
            },
            paginaActual: 1,
            registrosPorPagina: 50,
            tableScrollWidth: 3000
        };
        this.tableContainerRef = React.createRef();
    }

    componentDidMount() {
        this.cargarListadoServicios();
    }

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState(prevState => ({
            filtros: {
                ...prevState.filtros,
                [name]: type === 'checkbox' ? checked : value
            }
        }));
    };

    cargarListadoServicios = () => {
        this.setState({ cargando: true });
        Swal.showLoading();

        const { filtros } = this.state;
        const payload = {
            fecha_inicio: filtros.fecha_inicio,
            fecha_fin: filtros.fecha_fin,
            estado: filtros.estado,
            numero_expediente: filtros.numero_expediente,
            orden_servicio_new: filtros.orden_servicio_new,
            cliente_id: filtros.cliente_id,
            mostrar_costo_conductor_nc: filtros.mostrar_costo_conductor_nc
        };

        authAxios.post("exterior/nuevo-reporte-servicios", payload)
            .then((res) => {
                Swal.close();
                if (res.data && res.data.data) {
                    this.setState({
                        servicios: res.data.data,
                        estadosList: res.data.estados || [],
                        clientesList: res.data.clientes || [],
                        datosCargados: true,
                        cargando: false,
                        paginaActual: 1
                    });
                } else {
                    this.setState({ servicios: [], cargando: false });
                }
            })
            .catch((err) => {
                Swal.close();
                console.error("Error cargando listado de servicios:", err);
                this.setState({ cargando: false });
                Swal.fire({
                    icon: 'error',
                    title: 'Error de Conexión',
                    text: 'No se pudo consultar la API de servicios'
                });
            });
    };

    limpiarFiltros = () => {
        this.setState({
            filtros: {
                fecha_inicio: '2026-09-01',
                fecha_fin: '2026-09-30',
                estado: '',
                numero_expediente: '',
                orden_servicio_new: '',
                cliente_id: '',
                mostrar_costo_conductor_nc: false
            }
        }, () => {
            this.cargarListadoServicios();
        });
    };

    exportarExcel = () => {
        const { servicios } = this.state;
        if (!servicios || servicios.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'No hay servicios cargados en la lista para exportar.'
            });
            return;
        }

        const formattedData = servicios.map(item => {
            let numFactura = 'Sin Factura';
            let fechaFactura = 'N/A';
            let valorFactura = item.valor_factura || 0;
            if (item.factura_prefactura) {
                const parts = item.factura_prefactura.split('||');
                numFactura = parts[0] || 'Sin Factura';
                fechaFactura = parts[1] || 'N/A';
            }

            const numExpediente = item.posicion ? `${item.numero_expediente}-${item.posicion}` : item.numero_expediente;
            const nombreCiudad = String(item.ciudad) === '11001000' ? 'BOGOTA' : 'FUERA DE BOGOTA';

            return {
                'CLIENTE': item.cliente,
                'NOMBRE CLIENTE': item.nombre_cliente,
                'FECHA': item.fecha,
                'NUMERO EXPEDIENTE': numExpediente,
                'ORDEN SERVICIO': item.orden_servicio_new,
                'POSICION': item.posicion || '',
                'ID SERVICIO': item.id,
                'ESTADO SERVICIO': item.estado_servicio,
                'PRODUCCION': item.produccion,
                'NOMBRE MODALIDAD': item.nombre_modalidad,
                'CANTIDAD': item.cantidad,
                'ID CONDUCTOR': item.conductor,
                'NOMBRE CONDUCTOR': item.nombre_conductor,
                'PLACA': item.placa,
                'VEHICULO SUMINISTRADO': item.especificaciones || '',
                'VEHICULO CLIENTE': item.vehiculo_cliente,
                'VALOR SERVICIO': item.valor_servicio,
                'FACTURA': numFactura,
                'VALOR FACTURA': valorFactura,
                'FECHA FACTURA': fechaFactura,
                'COSTO TERCERO': item.costo_tercero,
                'COSTO CONDUCTOR NC': item.costo_conductor,
                'HORA INICIAL': item.hora_inicial,
                'CIUDAD': nombreCiudad,
                'DIRECCION INICIAL': item.direccion_inicial,
                'DIRECCION FINAL': item.direccion_final,
                'OBSERVACIONES': item.observaciones
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');

        XLSX.writeFile(workbook, `Reporte_Servicios_${new Date().toISOString().split('T')[0]}.xlsx`);

        Swal.fire({
            icon: 'success',
            title: '¡Exportado!',
            text: `Se han exportado ${servicios.length} registros a Excel.`,
            timer: 2000,
            showConfirmButton: false
        });
    };

    render() {
        const { 
            servicios, estadosList, clientesList, filtros, 
            cargando 
        } = this.state;

        return (
            <div className="container-fluid py-4">
                <div className="card shadow mb-4">
                    <div className="card-header py-3 d-flex flex-wrap align-items-center justify-content-between bg-white">
                        <h6 className="m-0 font-weight-bold text-primary" style={{ fontSize: '1.25rem' }}>
                            Reporte de Servicios
                        </h6>
                    </div>

                    <div className="card-body">
                        {/* Area de Filtros */}
                        <div className="p-3 mb-4 rounded" style={{ backgroundColor: '#f8f9fc', border: '1px solid #e3e6f0' }}>
                            <div className="row g-2 align-items-end">
                                <div className="col-md-2 col-sm-6">
                                    <label className="form-label mb-1" style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#5a5c69' }}>Fecha Inicio</label>
                                    <input type="date" name="fecha_inicio" value={filtros.fecha_inicio} onChange={this.handleInputChange} className="form-control form-control-sm" />
                                </div>
                                <div className="col-md-2 col-sm-6">
                                    <label className="form-label mb-1" style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#5a5c69' }}>Fecha Fin</label>
                                    <input type="date" name="fecha_fin" value={filtros.fecha_fin} onChange={this.handleInputChange} className="form-control form-control-sm" />
                                </div>
                                <div className="col-md-3 col-sm-6">
                                    <label className="form-label mb-1" style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#5a5c69' }}>Cliente</label>
                                    <select name="cliente_id" value={filtros.cliente_id} onChange={this.handleInputChange} className="form-control form-control-sm">
                                        <option value="">Seleccione el cliente</option>
                                        {clientesList.map(c => (
                                            <option key={c.id} value={c.id}>{c.id} - {c.nombre_cliente}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2 col-sm-6">
                                    <label className="form-label mb-1" style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#5a5c69' }}>Estado</label>
                                    <select name="estado" value={filtros.estado} onChange={this.handleInputChange} className="form-control form-control-sm">
                                        <option value="">Todos los estados</option>
                                        {estadosList.map(e => (
                                            <option key={e.id} value={e.id}>{e.nombre}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2 col-sm-6">
                                    <label className="form-label mb-1" style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#5a5c69' }}>Expediente</label>
                                    <input type="text" name="numero_expediente" value={filtros.numero_expediente} onChange={this.handleInputChange} placeholder="Nº Expediente" className="form-control form-control-sm" />
                                </div>
                                <div className="col-md-2 col-sm-6 mt-3">
                                    <label className="form-label mb-1" style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#5a5c69' }}>Orden Serv.</label>
                                    <input type="text" name="orden_servicio_new" value={filtros.orden_servicio_new} onChange={this.handleInputChange} placeholder="Nº Orden" className="form-control form-control-sm" />
                                </div>
                                <div className="col-md-3 col-sm-6 mt-3">
                                    <div className="form-check pt-4">
                                        <input type="checkbox" className="form-check-input" id="mostrar_costo_conductor_nc" name="mostrar_costo_conductor_nc" checked={filtros.mostrar_costo_conductor_nc} onChange={this.handleInputChange} />
                                        <label className="form-check-label" htmlFor="mostrar_costo_conductor_nc" style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#5a5c69' }}>
                                            Mostrar Costo Conductor NC
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-9 mt-3 d-flex gap-2">
                                    <button onClick={this.cargarListadoServicios} disabled={cargando} className="btn btn-primary btn-sm px-3 shadow-sm">
                                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                                        {cargando ? 'Buscando...' : 'Buscar'}
                                    </button>
                                    <button onClick={this.limpiarFiltros} disabled={cargando} className="btn btn-secondary btn-sm px-3 shadow-sm">
                                        <FontAwesomeIcon icon={faUndo} className="me-2" />
                                        Limpiar
                                    </button>
                                    <button onClick={this.exportarExcel} disabled={cargando || servicios.length === 0} className="btn btn-success btn-sm px-3 shadow-sm">
                                        <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                                        Exportar
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Contenedor de la Tabla */}
                        <div className="table-responsive" ref={this.tableContainerRef} style={{ maxHeight: '600px', overflowY: 'auto' }}>
                            <table className="table table-bordered table-hover table-sm text-center align-middle" style={{ fontSize: '0.85rem', minWidth: '2000px' }}>
                                <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                    <tr>
                                        <th>Cliente</th>
                                        <th>Nombre Cliente</th>
                                        <th>Fecha</th>
                                        <th>Nº Expediente</th>
                                        <th>Orden Serv.</th>
                                        <th>Posición</th>
                                        <th>ID Serv.</th>
                                        <th>Estado</th>
                                        <th>Producción</th>
                                        <th>Modalidad</th>
                                        <th>Cantidad</th>
                                        <th>ID Conductor</th>
                                        <th>Nombre Conductor</th>
                                        <th>Placa</th>
                                        <th>Vehículo Suministrado</th>
                                        <th>Vehículo Cliente</th>
                                        <th>Valor Serv.</th>
                                        <th>Factura</th>
                                        <th>Valor Factura</th>
                                        <th>Fecha Factura</th>
                                        <th>Costo Tercero</th>
                                        {filtros.mostrar_costo_conductor_nc && <th>Costo Conductor NC</th>}
                                        <th>Hora Inicial</th>
                                        <th>Ciudad</th>
                                        <th>Dir. Inicial</th>
                                        <th>Dir. Final</th>
                                        <th>Observaciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {servicios.length > 0 ? (
                                        servicios.map(s => {
                                            let fFactura = 'Sin Factura';
                                            let fFecha = 'N/A';
                                            let fValor = s.valor_factura || 0;
                                            if (s.factura_prefactura) {
                                                const parts = s.factura_prefactura.split('||');
                                                fFactura = parts[0] || 'Sin Factura';
                                                fFecha = parts[1] || 'N/A';
                                            }
                                            
                                            const numExpediente = s.posicion ? `${s.numero_expediente}-${s.posicion}` : s.numero_expediente;
                                            const nombreCiudad = String(s.ciudad) === '11001000' ? 'BOGOTA' : 'FUERA DE BOGOTA';

                                            return (
                                            <tr key={s.id}>
                                                <td>{s.cliente}</td>
                                                <td>{s.nombre_cliente}</td>
                                                <td>{s.fecha}</td>
                                                <td>{numExpediente}</td>
                                                <td>{s.orden_servicio_new}</td>
                                                <td>{s.posicion}</td>
                                                <td>{s.id}</td>
                                                <td><span className="badge bg-secondary">{s.estado_servicio}</span></td>
                                                <td>{s.produccion}</td>
                                                <td>{s.nombre_modalidad}</td>
                                                <td>{s.cantidad}</td>
                                                <td>{s.conductor}</td>
                                                <td>{s.nombre_conductor}</td>
                                                <td>{s.placa}</td>
                                                <td>{s.especificaciones}</td>
                                                <td>{s.vehiculo_cliente}</td>
                                                <td>{Number(s.valor_servicio).toLocaleString()}</td>
                                                <td>{fFactura}</td>
                                                <td>{Number(fValor).toLocaleString()}</td>
                                                <td>{fFecha}</td>
                                                <td>{Number(s.costo_tercero).toLocaleString()}</td>
                                                {filtros.mostrar_costo_conductor_nc && <td>{s.costo_conductor ? Number(s.costo_conductor).toLocaleString() : 'N/A'}</td>}
                                                <td>{s.hora_inicial}</td>
                                                <td>{nombreCiudad}</td>
                                                <td className="text-truncate" style={{ maxWidth: '150px' }} title={s.direccion_inicial}>{s.direccion_inicial}</td>
                                                <td className="text-truncate" style={{ maxWidth: '150px' }} title={s.direccion_final}>{s.direccion_final}</td>
                                                <td className="text-truncate" style={{ maxWidth: '150px' }} title={s.observaciones}>{s.observaciones}</td>
                                            </tr>
                                        )})
                                    ) : (
                                        <tr>
                                            <td colSpan="22" className="text-center py-4 text-muted">
                                                {cargando ? 'Cargando registros...' : 'No se encontraron registros para los filtros seleccionados.'}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        
                        {/* Se quitó el paginador */}
                    </div>
                </div>
            </div>
        );
    }
}

export default NuevoReporte;
